module.exports = __webpack_public_path__ + "static/brain_in_a_jar-2a63ede5949d20e89b59852c3fd045b4.jpg";